__turbopack_context__.v({
  "Separator": "RepositoriesList-module-scss-module__HTxDJW__Separator",
  "connectButton": "RepositoriesList-module-scss-module__HTxDJW__connectButton",
  "details": "RepositoriesList-module-scss-module__HTxDJW__details",
  "emptyData": "RepositoriesList-module-scss-module__HTxDJW__emptyData",
  "expItem": "RepositoriesList-module-scss-module__HTxDJW__expItem",
  "label": "RepositoriesList-module-scss-module__HTxDJW__label",
  "link": "RepositoriesList-module-scss-module__HTxDJW__link",
  "list": "RepositoriesList-module-scss-module__HTxDJW__list",
  "primaryLabel": "RepositoriesList-module-scss-module__HTxDJW__primaryLabel",
  "profileLink": "RepositoriesList-module-scss-module__HTxDJW__profileLink",
  "root": "RepositoriesList-module-scss-module__HTxDJW__root",
  "row": "RepositoriesList-module-scss-module__HTxDJW__row",
  "secondaryLabel": "RepositoriesList-module-scss-module__HTxDJW__secondaryLabel",
});
